import React from 'react';
import { Plugin, CustomEditor } from '../types';

const TablePlugin: Plugin = {
  name: 'table',
  
  commands: {
    insertTable: (editor: CustomEditor, rows: number, cols: number) => {
      // Create table structure
      const tableElement = {
        type: 'table' as const,
        rows,
        cols,
        children: Array.from({ length: rows }, (_, rowIndex) => ({
          type: 'table-row' as const,
          children: Array.from({ length: cols }, (_, colIndex) => ({
            type: 'table-cell' as const,
            header: rowIndex === 0,
            children: [{ text: rowIndex === 0 ? `Header ${colIndex + 1}` : `Cell ${rowIndex + 1}-${colIndex + 1}` }]
          }))
        }))
      };
      
      // Insert table at current selection
      const { insertNode } = editor;
      insertNode(tableElement);
    }
  },

  renderElement: (props) => {
    const { attributes, children, element } = props;
    
    if (element.type === 'table') {
      return (
        <table {...attributes} style={{ borderCollapse: 'collapse', width: '100%', margin: '1em 0' }}>
          <tbody>{children}</tbody>
        </table>
      );
    }
    
    if (element.type === 'table-row') {
      return <tr {...attributes}>{children}</tr>;
    }
    
    if (element.type === 'table-cell') {
      const isHeader = (element as any).header;
      const Tag = isHeader ? 'th' : 'td';
      return (
        <Tag 
          {...attributes} 
          style={{ 
            border: '1px solid #d1d5db', 
            padding: '8px', 
            textAlign: 'left',
            backgroundColor: isHeader ? '#f3f4f6' : 'white'
          }}
        >
          {children}
        </Tag>
      );
    }
    
    return undefined;
  }
};

export default TablePlugin; 